import { createFileRoute } from "@tanstack/react-router";
import PricingPage from "@/pages/PricingPage";
import { createTranslationInstance } from "@/i18n";
import { resolveLocale } from "@/lib/locale";
import { publicLanguageLinks } from "@/lib/publicLocale";

export const Route = createFileRoute("/pricing")({
  loader: () => ({ locale: resolveLocale() }),
  head: ({ loaderData }) => {
    const translations = createTranslationInstance(loaderData?.locale ?? "en");
    const title = `${translations.t("pricing.badge")} | System Atlas`;
    const description = `${translations.t("offerDetails.freeSheets")}. ${translations.t("pricing.freeTrial")}. ${translations.t("offerDetails.card")}`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://systematlas.fr/pricing" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: "https://systematlas.fr/pricing" }, ...publicLanguageLinks("/pricing")],
    };
  },
  component: PricingPage,
});
